import React from 'react'
import PropTypes from 'prop-types'
import {
  Icon,
  TutorialTooltip,
  utils,
  hooks,
  useApplicationContext,
} from '@adc/ui-adc'
import classnames from 'classnames/bind'
import { useListingContext } from '../../context/listing'
import { getPurchasePaths } from '../../utils/listingPaths'
import PopupTooltip from '../../components/popupTooltip'
import styles from './index.scss'

const cx = classnames.bind(styles)

const { getDisplayIndicator } = utils

const SingleBadge = ({ listing, showTutorial, showTooltip = true }) => {
  const assetDisplayInfo = getDisplayIndicator(listing) || {}
  const breakpoint = hooks.useBreakpoints()
  const isMobile = breakpoint === 'mobile'
  const tooltipContent =
    (showTooltip && assetDisplayInfo.description?.length && (
      <span>
        {assetDisplayInfo.description.map((value, index) => (
          <p key={`tooltip_description_${index}`}>{value}</p>
        ))}
      </span>
    )) ||
    null
  const tooltipTrigger = assetDisplayInfo.tooltipIconSvg ? (
    <img
      data-elm-id='asset_type_popup'
      className={cx('tooltip-image')}
      src={assetDisplayInfo.tooltipIconSvg}
    />
  ) : (
    <Icon data-elm-id='asset_type_popup' name='info circle' />
  )

  const labelContent = (
    <span className={cx('label')} data-elm-id='asset_type_label'>
      {assetDisplayInfo.label}
    </span>
  )

  return (
    <>
      <img
        src={assetDisplayInfo.iconSvg}
        className={cx('dot')}
        alt={assetDisplayInfo.label}
      />
      {showTutorial ? (
        <TutorialTooltip
          elmId='property_type_tutorial_tooltip'
          tutorial={1}
          header='Check Property Type'
          position='right center'
          mobilePosition='bottom center'
          content='Find out how this property will be sold.'
        >
          {labelContent}
        </TutorialTooltip>
      ) : (
        labelContent
      )}
      {tooltipContent && (
        <PopupTooltip
          content={tooltipContent}
          elmId='asset_type_info_tooltip'
          position={isMobile ? 'default' : 'right center'}
          trigger={tooltipTrigger}
        />
      )}
    </>
  )
}

const AssetType = ({ listing, showTutorial = false }) => {
  const { featureFlags } = useApplicationContext()
  const { activeListings } = useListingContext()

  const unifiedPdpEnabled = featureFlags?.['fe.resi.enable-unified-pdp']

  const paths = getPurchasePaths(activeListings)
  const showBoth = unifiedPdpEnabled && paths.length > 1

  if (showBoth) {
    return (
      <div className={cx('asset-type')}>
        {paths.map((path, i) => (
          <React.Fragment key={path.type}>
            {i > 0 && <span className={cx('badge-divider')} />}
            <SingleBadge
              listing={path.listing}
              showTutorial={i === 0 ? showTutorial : false}
              showTooltip={i > 0}
            />
          </React.Fragment>
        ))}
      </div>
    )
  }

  return (
    <div className={cx('asset-type')}>
      <SingleBadge listing={listing} showTutorial={showTutorial} />
    </div>
  )
}

AssetType.propTypes = {
  listing: PropTypes.object,
  showTutorial: PropTypes.bool,
}

export default AssetType
